import { Connection } from 'models';

//This is slowly being refactored avoiding adding new stuff
export class SuperhogDashboard {
	connections: Connection[];
	reviews: string[];
	reviewCount: number;
	numberOfBookings: number;
}

export class MembershipPricingTier {
	id: number;
	price: number;
	paymentOptionId: number;
	paymentOptionName: string;
	setupFee: number;
	managementFee: number;
	currencyIso: string;
}

export class AuthOnly {
	companyId: string;
	companyMidId: string;
	amount: string;
	currencyCode: string;
	billingStreet: string;
	billingStreet2: string;
	billingZipcode: string;
	billingCity: string;
	billingCountryCodeIso2: string;
	billingEmail: string;
	merchantOrderId: string;
	transactionType: string;
	customerFirstName: string;
	customerLastName: string;
	customerDateOfBirth: string;
	merchantCustomerId: string;

	isThreeDSecure: string;
	merchantContactUrl: string;
	threeDSecureSource: string;
	threeDSecureType: string;
	threeDSecurePreference: string;
	hash: string;

	merchantCustomOne: string;
	merchantCustomTwo: string;
	merchantCustomThree: string;

	returnUrl: string;
	callbackUrl: string;
	errorUrl: string;
	cancelUrl: string;
}

export class SuperhogCreateMembership {
	userId: string;
	start: Date;
}

export enum MembershipType {
	Host = 1,
	Guest = 2,
}
